import React from 'react';

import './Home.less';
import { isUserInstructor } from '@helpers';

import { StudentDashboard } from '@new/features/dashboard/pages/StudentDashboard';
import { InstructorDashboard } from '@new/features/dashboard/pages/InstructorDashboard';
import { useGetCurrentUserQuery } from '@teachur/http-client';

const Home: React.FC = () => {
  const { data: user } = useGetCurrentUserQuery();
  if (!user) {
    return null;
  }

  if (isUserInstructor(user)) {
    return <InstructorDashboard user={user} />;
  }

  return <StudentDashboard />;
};

export default Home;
